<template>
  <div class="" style="position:fixed">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

  <br>
  <form id="form-upload-tender-document">
        <b-row style="width:100vw">
                <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
                    <AdminSideNav />
                </b-col>
                <b-col col cols="12" sm="12" md="9" lg="9" style="height:78vh; overflow-y:scroll " class="shadow">
                  <b-row>
                    <b-col col cols="12" sm="12" md="12" lg="12">
                     <h1 class="heading">Upload Tender Documents</h1>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col col cols="12" sm="12" md="2" lg="2" class="text-left">
                      <h6>New Document: </h6>
                    </b-col>
                    <b-col col cols="12" sm="12" md="10" lg="10">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <span  style="display: flex;">
                         <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="Y">
                           Yes
                         </b-form-radio>
                         <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="N" style="padding-left: 50px;">
                           No
                         </b-form-radio>
                       </span>
                       </b-form-group>

                       <div class="mt-3" id="radioSelect" hidden>{{ selected }}</div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col col cols="12" sm="2" md="2" lg="2" class="text-left">
                      <h6>Select Tender: </h6>
                    </b-col>
                    <b-col col cols="12" sm="10" md="10" lg="10" >

                      <select id="tenderList" class="browser-default" name="tenderList" placeholder="Choose your option" style="background-color: #fafafa; width:100%;">
                        <!-- <option value="" disabled selected>Choose your option</option> -->
                      </select>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="2" md="2" lg="2" class="text-left">
                      <h6>Document Type: </h6>
                    </b-col>
                    <b-col col cols="12" sm="4" md="4" lg="4">
                      <select id="tenderDocType" class="browser-default" name="tenderDocType" placeholder="Choose your option" style="background-color: #fafafa; width:100% !important;">
                        <!-- <option value="" disabled selected>Choose your option</option> -->
                      </select>
                    </b-col>
                    <b-col col cols="12" sm="2" md="2" lg="2" class="text-left">
                      <h6>Document Name: </h6>
                    </b-col>
                    <b-col col cols="12" sm="4" md="4" lg="4">
                      <input id="documentName" v-model="documentName" type="text" class="validate" style="width: 100%;" name="documentName" placeholder="Enter Document Name">
                      <!-- <p id="documentNamePath" hidden>Download {{ documentName }} </p> -->
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="2" md="2" lg="2" class="text-left">
                      <h6>Upload Date: </h6>
                    </b-col>
                    <b-col col cols="12" sm="4" md="4" lg="4">
                      <b-form-datepicker id=""
                      v-model="uploadDate"
                      class="mb-2">
                      </b-form-datepicker>
                      <p id="uploadDate" hidden>{{ uploadDate }}</p>
                    </b-col>

                    <b-col col cols="12" sm="2" md="2" lg="2" class="text-left">
                      <h6>Upload File: </h6>
                    </b-col>
                    <b-col col cols="12" sm="4" md="4" lg="4">
                      <b-form-file
                        v-model="tenderDocument"
                        :state="Boolean(tenderDocument)"
                        id="tenderDocument">
                        </b-form-file>
                      <!-- <div class="mt-3" id="tenderDocumentPath">docs/tender/{{ tenderDocument ? tenderDocument.name : '' }}</div> -->
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="6" sm="6" md="2" lg="2" offset-md="4" offset-lg="4" class="text-center">
                      <b-button variant="info" @click="uploadTenderDocument($event)">UPLOAD</b-button>
                    </b-col>
                    <b-col col cols="6" sm="6" md="2" lg="2" class="text-center">
                      <b-button variant="outline-danger">CANCEL</b-button>
                    </b-col>
                  </b-row>

            </b-col>
      </b-row>
    </form>
      </b-container>
      <br><br>
</b-overlay>


      <b-modal   no-close-on-esc  no-close-on-backdrop   hide-header id="successModal" centered  scrollable title="Complaint Update" hide-footer>
        <br><br><svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
        <p class="success">Document Uloaded Successfully !<br><br>
        <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage();" >OK</b-button>
        </p>
      </b-modal>
      <b-modal  no-close-on-esc  no-close-on-backdrop   hide-header id="failureModal" centered  scrollable title="Complaint Update" hide-footer>
      <br><br>  <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
        </svg>
        <p class="error">Document Upload Failed ! <br><br>
          <b-button class="btn btn-outline" variant="danger" id="" @click="reloadPage();" >OK</b-button>
           </p>
      </b-modal>
  </div>
</template>

<script>
import AdminSideNav from '@/components/AdminSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex';

//var urlCommon = "https://portald.apdcl.org/website";
var urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var selectedId = null;
export default {
  name: 'Admin',
  components: {
    'AdminSideNav' : AdminSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  data() {
      return {
        value: '',
        selected: 'Y',
        uploadDate: '',
        documentName: '',
        tenderDocument: '',
        show: false,
      }
    },
    computed:
    {
      ...mapGetters([
        'getZoneData',
        'getKeyOfficial',
        'getCircleContact',
        'getDivisionContact',
        'getSubDivContact',
        'getIRCAContact',
        'getTCContact'
      ])

    },

  methods:
  {
    ...mapActions([
      'retrieveContactInfo'
    ]),
    uploadTenderDocument(event){
      event.stopPropagation()
      event.preventDefault()

      var uploadDate = document.getElementById("uploadDate").innerHTML;
      var uploadDateSplit = uploadDate.split("-");
      uploadDate = uploadDateSplit[2]+"/"+uploadDateSplit[1]+"/"+uploadDateSplit[0];

      let formData = new FormData();

      var docTitle = document.getElementById("documentName").value;

      if(docTitle === ""){
        docTitle = "Download";
      }

      formData.append('new_flag', document.getElementById("radioSelect").innerHTML);
      formData.append('tender_no', document.getElementById("tenderList").value);
      formData.append('type', document.getElementById("tenderDocType").value);
      formData.append('file_location', document.getElementById("tenderDocument").files[0]);
      formData.append('date', uploadDate);
      // formData.append('title', document.getElementById("documentName").value);
      formData.append('title', docTitle);

      for(let [name, value] of formData) {
        console.log(`${name} = ${value}`); // key1 = value1, then key2 = value2
      }

      axios.post(urlCommon + "/api/admin/uploadtenderdocs", formData,  {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
        console.log(response)
      })

      // var dataToSend = {
      //   "new_flag": document.getElementById("radioSelect").innerHTML,
      //   "tender_no": document.getElementById("tenderList").value,
      //   "type": document.getElementById("tenderDocType").value,
      //   "file_location": document.getElementById("tenderDocumentPath").innerHTML,
      //   "date": uploadDate,
      //   "title": document.getElementById("documentNamePath").innerHTML
      // }

      // console.log(dataToSend)
      //
      // var parent = this;
      // parent.show=true;
      // axios.post( urlCommon + "/api/admin/uploadtenderdocs", dataToSend).then(function(response) {
      //   console.log(response)
      //   parent.show=false;
      //   if (response.data == "success") {
      //     document.getElementById("form-upload-tender-document").reset()
      //     parent.$bvModal.show('successModal');
      //   } else {
      //     document.getElementById("form-upload-tender-document").reset()
      //     parent.$bvModal.show('profilefailureModal');
      //   }
      // })


    },

    reloadPage()
    {
      window.location.reload();
    }
  },
  mounted()
  {
    var userId = localStorage.getItem("userId");
    var userName = localStorage.getItem("userName");
    var roles = localStorage.getItem("roleSet");
    if(userId==null)
      {
        this.$router.push({ path: '/' })
        return;
      }
    var i =0;
    var res= roles.split(",");

    for(i=0;i<res.length;i++)
     {
       document.getElementById(res[i]).style.display="block";
     }
     document.getElementById("consName").innerHTML = userName ;

     axios.get(urlCommon + "/api/admin/gettender").then(function(response) {
       var x = document.getElementById("tenderList");

       var option = document.createElement("option");
       option.text = "Choose your option";
       option.value = "";
       x.options.add(option);

       response.data.forEach(element => {
         var option = document.createElement("option");
         option.text = element;
         option.value = element;
         x.options.add(option);
       })
     })

     axios.get(urlCommon + "/api/admin/gettenderdoctype").then(function(response) {
       var x = document.getElementById("tenderDocType");

       var option = document.createElement("option");
       option.text = "Choose your option";
       option.value = "";
       x.options.add(option);
       // console.log(response.data);
       response.data.forEach(element => {
         var option = document.createElement("option");
         option.text = element[1];
         option.value = element[0];
         x.options.add(option);
       })
     })
  }

}


</script>

<style scoped="true">

.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #0097a7 ;
}

li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }


    .path {
      stroke-dasharray: 1000;
      stroke-dashoffset: 0;
    }
    .path.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    .path.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    .path.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }

    p {
      text-align: center;
      margin: 20px 0 60px;
      font-size: 1.25em;
    }
    p.success {
      color: #73AF55;
    }
    p.error {
      color: #D06079;
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @-webkit-keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
    @keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
</style>
